<app-header></app-header>

<div class="layout-wrapper">
  <div class="layout-grid">
    
    <!-- LEFT: MAIN CONTENT -->
    <main class="content-panel">
      <router-outlet></router-outlet>
    </main>

  </div>
</div>

<app-footer></app-footer>
